import React from 'react';

const QuestLayout = props => <div>{props.children}</div>;

export default QuestLayout;
